const DEFAULT_BASE_URL = "https://localhost:43124";

function isAllowedLocalPrintBaseUrl(value) {
  return /^https:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(value) ||
    /^https:\/\/([a-z0-9.-]+\.)?printerapp\.chitchats\.com(:\d+)?$/i.test(value);
}

function getBaseUrl() {
  // Dev/staging override. Keep this tightly allowlisted so a poisoned
  // localStorage entry cannot redirect print app traffic or downgrade Safari
  // back onto mixed-content HTTP/WS.
  var override = window.localStorage.getItem("chitChatsPrintBaseUrl");
  if (override && override.length > 0 && isAllowedLocalPrintBaseUrl(override)) {
    return override;
  }
  return DEFAULT_BASE_URL;
}

export {
  DEFAULT_BASE_URL,
  getBaseUrl,
  isAllowedLocalPrintBaseUrl
};
